import {
  IonButton,
  IonContent,
  IonIcon,
  IonItem,
  IonList,
  IonListHeader,
  IonModal,
  IonPopover,
  IonSelect,
  IonSelectOption,
  IonText,
} from "@ionic/react";
import { cloudCircleOutline, helpCircleOutline, pencilOutline, removeCircleOutline ,trashOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setShowAnullModal,
  setShowAbandonModal,
  setShowUpdateArchiveModal,
  setShowUpdateDocumentModal,
} from "../../../store/documentShow";
import { selectDocumentStatus } from "../../../store/documentShow/selectors/selectDocumentStatus";

export const DocumentHelperActions: React.FC = () => {
  const dispatch = useDispatch();
  const status = useSelector(selectDocumentStatus);
  const [showModal, setShowModal] = useState(false);

  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  return (
    <>
      <IonButton onClick={() => setShowModal(true)}>
        <IonIcon icon={helpCircleOutline} slot="start" />
        <IonText>Acciones</IonText>
      </IonButton>
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        cssClass={"modal-fix-popover"}
      >
        <IonContent>
          <IonList>
            <IonListHeader>
              <h3>Acciones</h3>
            </IonListHeader>
            {(status?.code === "preparing" || status?.code === "rejected") && (
              <>
                <IonItem
                  button
                  lines="none"
                  onClick={() => {
                    dispatch(setShowUpdateDocumentModal(true));
                    setShowModal(false);
                    // setShowPopover({ showPopover: false, event: undefined });
                  }}
                >
                  <IonIcon icon={pencilOutline} />
                  <IonText class="ion-padding-start">Editar acuerdo</IonText>
                </IonItem>
                <IonItem
                  button
                  lines="none"
                  onClick={() => {
                    dispatch(setShowUpdateArchiveModal(true));
                    setShowModal(false);
                    // setShowPopover({ showPopover: false, event: undefined });
                  }}
                >
                  <IonIcon icon={cloudCircleOutline} />
                  <IonText class="ion-padding-start">Actualizar archivo</IonText>
                </IonItem>
              </>
            )}

            {status?.code !== 'abandoned'  && (
              <IonItem
                button
                lines="none"
                onClick={() => {
                  dispatch(setShowAbandonModal(true));
                  setShowModal(false);
                }}
              >
                <IonIcon icon={removeCircleOutline} color="danger" />
                <IonText class="ion-padding-start" color="danger">
                  Acuerdo abandonado
                </IonText>
              </IonItem>
            )}
            {!["anulled", "fulfilled", "sync"].includes(status?.code || "") && (
              <IonItem
                button
                lines="none"
                onClick={() => {
                  dispatch(setShowAnullModal(true));
                  setShowModal(false);
                  // setShowPopover({ showPopover: false, event: undefined });
                }}
              >
                <IonIcon icon={trashOutline} color="danger" />
                <IonText class="ion-padding-start" color="danger">
                  Anular acuerdo
                </IonText>
              </IonItem>
            )}
          </IonList>
        </IonContent>
      </IonModal>

      {/* {!["anulled", "fulfilled", "sync"].includes(status?.code || "") && (
        <IonButton
          id="size-button"
          onClick={(e: any) => {
            e.persist();
            setShowPopover({ showPopover: true, event: e });
          }}
        >
          <IonIcon icon={helpCircleOutline} slot="start" />
          <IonText>Acciones</IonText>
        </IonButton>
      )} */}

      {/* <IonPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        <IonContent>
          <IonList>
            <IonListHeader>
              <h3>Acciones</h3>
            </IonListHeader>
            {(status?.code === "preparing" || status?.code === "rejected") && (
              <>
                <IonItem
                  button
                  lines="none"
                  onClick={() => {
                    dispatch(setShowUpdateDocumentModal(true));
                    setShowPopover({ showPopover: false, event: undefined });
                  }}
                >
                  <IonIcon icon={pencilOutline} />
                  <IonText class="ion-padding-start">Editar acuerdo</IonText>
                </IonItem>
                <IonItem
                  button
                  lines="none"
                  onClick={() => {
                    dispatch(setShowUpdateArchiveModal(true));
                    setShowPopover({ showPopover: false, event: undefined });
                  }}
                >
                  <IonIcon icon={cloudCircleOutline} />
                  <IonText class="ion-padding-start">Actualizar archivo</IonText>
                </IonItem>
              </>
            )}

            {!["anulled", "fulfilled", "sync"].includes(status?.code || "") && (
              <IonItem
                button
                lines="none"
                onClick={() => {
                  dispatch(setShowAnullModal(true));
                  setShowPopover({ showPopover: false, event: undefined });
                }}
              >
                <IonIcon icon={trashOutline} color="danger" />
                <IonText class="ion-padding-start" color="danger">
                  Anular acuerdo
                </IonText>
              </IonItem>
            )}
          </IonList>
        </IonContent>
      </IonPopover> */}
    </>
  );
};
